export class ProfileRoleLevel {
  public createdAt?: Date;
  public updatedAt?: Date;
  public dataSource?: string;
  public hasSpecialty?: boolean;
  public name: string;
  public slug: string;
  public token: string;
  public type: string;
}
